import { useState } from "react"

import { useParams } from "react-router-dom"
import { MainContainer } from "./Dataset.styled"
import DatasetDetail from "./DatasetDetail"
import DatasetTable from "./DatasetTable"
import Sidebar from "./Sidebar"
import { DatasetFilters } from "./types"

const Dataset = () => {
  const [searchText, setSearchText] = useState("")
  const [filters, setFilters] = useState<DatasetFilters>({})

  const { datasetId } = useParams()

  const handleFilterChange = (newFilters: Partial<DatasetFilters>) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      ...newFilters,
    }))
  }

  if (datasetId) {
    return <DatasetDetail />
  }

  return (
    <MainContainer>
      <DatasetTable filters={filters} />
      <Sidebar
        searchText={searchText}
        setSearchText={setSearchText}
        filters={filters}
        handleFilterChange={handleFilterChange}
      />
    </MainContainer>
  )
}

export default Dataset
